import { Component } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import JsonApiObject from '@/_models/JsonApiObject'

@Component({
    mixins: [ProjectMixin],
    components: { EditorViewer },
})
export default class InfoPublic extends Mixins<MixinInterface>(ProjectMixin) {
    get projectId() {
        return this.$route.params.type == 'p' ? this.$route.params.id : this.$route.query.projectId
    }

    get isInfo() {
        return this.$route.fullPath.includes('info')
    }
}
